import { FC, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserRoleContext } from '@components';
import { Role } from '@app/enums/Role';
import { CircularProgress, Grid } from '@mui/material';

interface RoleGuardProps extends React.PropsWithChildren {
  requiredRoles: Role[];
}

export const RoleGuard: FC<RoleGuardProps> = ({ requiredRoles, children }) => {
  const userRole = useContext(UserRoleContext);
  const navigate = useNavigate();

  const [hasAccess, setHasAccess] = useState<boolean | null>(null);

  useEffect(() => {
    if (!userRole || userRole == null) return;

    // compute access
    const allowed = requiredRoles.some((neededRole) => (userRole & neededRole) === neededRole);

    setHasAccess(allowed);

    if (!allowed) {
      navigate('/groups', { replace: true });
    }
  }, [userRole, requiredRoles, navigate]);

  return (
    <>
      {/** Loading State */}
      {(userRole == null || hasAccess === null) && (
        <Grid container justifyContent="center" alignItems="center">
          <CircularProgress />
        </Grid>
      )}

      {/** Allowed Content */}
      {hasAccess && children}
    </>
  );
};
